import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

export type CachedMe = { id?: string; appMode?: string | null; app_mode?: string | null } | null;

/** The signed-in user from the cache useAuth fills — READ ONLY. A second
 *  `useQuery` on ["/api/users/me"] without useAuth's queryFn became the
 *  query's last observer and swapped in the default queryFn, so the next
 *  refetch stored the raw snake_case row: `appMode` vanished and Pilot users
 *  were dropped into the full app (review of 1.3.160; same bug as the one
 *  NutritionCalculator documents). A cache subscription can't do that. */
export function useCachedMe(): CachedMe {
  const qc = useQueryClient();
  const read = () => (qc.getQueryData<CachedMe>(["/api/users/me"]) ?? null);
  const [me, setMe] = useState<CachedMe>(read);
  useEffect(() => qc.getQueryCache().subscribe((event) => {
    if (event?.query?.queryKey?.[0] === "/api/users/me") setMe(read());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [qc]);
  return me;
}
